import React from 'react';

import { SnackbarActionTypes, useSnackbarDispatch, useSnackbarState } from 'contexts/snackbar/SnackbarContext';

import { Alert, AlertTitle, Box, Button, styled, useTheme } from '@mui/material';
import Slide from '@mui/material/Slide';
import Snackbar from '@mui/material/Snackbar';
import { AlertTriangle } from 'lucide-react';
import { useIntl } from 'react-intl';

const SnackbarButton = styled(Button)(({ theme }) => ({
  color: theme.palette.darkBlue.main,
  borderColor: theme.palette.darkBlue.main,
  '&:hover': {
    color: theme.palette.darkBlue.main,
    borderColor: theme.palette.darkBlue.main,
  },
}));

const Root = styled(Alert)(({ theme }) => ({
  paddingLeft: '49px',
  backgroundColor: theme.palette.orange.o75,
  ['& .MuiAlert-message']: {
    width: '100%',
  },
  ['& .MuiAlert-action']: {
    button: {
      color: theme.palette.darkBlue.main,
    },
    marginLeft: 0,
    color: theme.palette.darkBlue.main,
  },
}));

type Props = {};

const WarningSnackbar: React.FC<Props> = () => {
  const { msg, isWarning } = useSnackbarState();
  const theme = useTheme();
  const dispatch = useSnackbarDispatch();
  const intl = useIntl();

  const handleClose = () => {
    dispatch({ type: SnackbarActionTypes.CLEAR_SNACKBAR });
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      onClose={handleClose}
      autoHideDuration={3000}
      open={isWarning}
      slots={{
        transition: Slide,
      }}
      key={Slide.name}>
      <Root elevation={6} variant="filled" onClose={handleClose} icon={false}>
        <Box
          sx={{
            padding: theme.spacing(4),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
          <AlertTriangle color={theme.palette.darkBlue.main} size={32} />
          <AlertTitle
            sx={{
              padding: theme.spacing(3, 0),
              fontSize: 20,
              color: theme.palette.darkBlue.main,
            }}>
            {msg || intl.formatMessage({ id: 'snackbar.warning.default' })}
          </AlertTitle>
          <SnackbarButton
            variant="outlined"
            fullWidth
            sx={{
              color: theme.palette.darkBlue.main,
              borderColor: theme.palette.darkBlue.main,
            }}
            onClick={handleClose}>
            {intl.formatMessage({ id: 'general.ok' })}
          </SnackbarButton>
        </Box>
      </Root>
    </Snackbar>
  );
};

export default WarningSnackbar;
